module.exports = {"onlySmartButtons":["kr-popin"]}